import React from "react";

function Icon(data) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            xmlSpace="preserve"
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              strokeLinejoin: "round",
              strokeMiterlimit: 2,
            }}
            width={data.w} height={data.h}
          >
            <path
              d="m16.08 31.25 5.26-5.68 1.77-.06-.06 1.65-5.93 5.5-1.04-1.41Z"
              style={{
                fill: "#ff8400",
                fillRule: "nonzero",
              }}
              transform="translate(-26.104 -22.2) scale(1.86726)"
            />
            <path
              style={{
                fill: "#3d3833",
              }}
              d="M22.29 21.99h7.95v1.09h-7.95z"
              transform="rotate(-44.16 8.61 63.156) scale(1.86726)"
            />
            <path
              d="M21.74 26h1v.77l-5.34 5.12-.87-.81L21.7 26m0-1.09c-.253.01-.494.109-.68.28l-5.74 5.66a.39.39 0 0 0 0 .57l1.86 1.73c.084.071.19.11.3.11a.42.42 0 0 0 .3-.12l5.82-5.58c.181-.19.287-.438.3-.7V25.4a.432.432 0 0 0-.41-.43l-1.73-.06h-.02ZM29.36 20.42l-1-.88-1.81-1.81L30 14.3l4.56 4.56s1.76 1.4.19 4c-1.28-1.22-2.29-2.3-2.29-2.3l-1.56 1.52-1.54-1.66ZM28.3 15.91v-3.05l-.48-.48-3.46 3.45.49.49h3.05l.4-.41ZM20.02 16.86v-1.54l-3.37-3.38-2.67 2.68 3.37 3.37h1.54l1.13-1.13Z"
              style={{
                fill: "#3d3833",
                fillRule: "nonzero",
              }}
              transform="translate(-26.104 -22.2) scale(1.86726)"
            />
            <path
              d="m28.3 25.22 5.15 5-1.16 1.16-5.18-5v-.7l.43-.44h.72m.06-1.08h-.81a1.13 1.13 0 0 0-.7.29l-.51.5a1.152 1.152 0 0 0-.29.7v.8c.017.261.123.508.3.7L32 32.62a.42.42 0 0 0 .58-.01l2.12-2.12a.39.39 0 0 0 0-.57l-5.68-5.48a1.14 1.14 0 0 0-.7-.28Z"
              style={{
                fill: "#ff8400",
                fillRule: "nonzero",
              }}
              transform="translate(-26.104 -22.2) scale(1.86726)"
            />
            <path
              style={{
                fill: "#3d3833",
              }}
              d="M21.65 16.24h1.09v7.95h-1.09z"
              transform="rotate(-44.17 1.034 58.813) scale(1.86726)"
            />
          </svg>
    );
  }

export default Icon;
